import instanceQuery from 'graphql/queries/supplier/PurchaseRefundTransactionQuery.graphql';
import fragment from 'graphql/fragments/nominal/PostedTransactionsFragment.graphql';

const PurchaseRefundTransactions = {
  type: 'PostedTransactionsResponse',
  formTitle: 'Posted Transactions',
  instance: instanceQuery,
  fragment,
};

export default PurchaseRefundTransactions;
